import { Text, View } from '@mirai/ui';
import React from 'react';

import * as style from './routes.module.css';

export const Signup = () => (
  <>
    <View tag="section" className={[style.section, style.box, style.accent]}>
      <View className={style.wrapper}>
        <Text bold brand headline level={1}>
          Signup
        </Text>
        <Text>Join Club Monalisa for free and enjoy exclusive benefits</Text>
      </View>
    </View>
    <View className={[style.wrapper, style.box]}>
      <View data-mirai-component="signup" />
    </View>
  </>
);
